"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_slot_1 = require("@radix-ui/react-slot");
const card_props_js_1 = require("./card.props.js");
const index_js_1 = require("../helpers/index.js");
const Card = React.forwardRef((props, forwardedRef) => {
    const { asChild, children: childrenProp, className, ...cardProps } = (0, index_js_1.extractProps)(props, card_props_js_1.cardPropDefs, index_js_1.marginPropDefs);
    const { Root: CardRoot, children } = (0, index_js_1.getRoot)({
        asChild,
        children: childrenProp,
        parent: asChild ? react_slot_1.Slot : 'div',
    });
    return (React.createElement(CardRoot, { ref: forwardedRef, ...cardProps, className: (0, classnames_1.default)('rt-reset', 'rt-Card', className) },
        React.createElement("div", { className: "rt-CardInner" }, children)));
});
exports.Card = Card;
Card.displayName = 'Card';
//# sourceMappingURL=card.js.map